import React from "react";

const Backend = () => {
   return(
      <div className="skills__content">
         <h3 className="skills__title">Backend Developer</h3>

         <div className="skills__box">                                            {/*Main skill block*/}
            <div className="skills__group">                                       {/*Group-1*/}
               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Python</h3>
                     <span className="skills__level">Advanced</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Node.js</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">MongoDB</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">PL/SQL</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">GitHub Actions</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>
            </div>

            <div className="skills__group">                                      {/*Group-2*/}
               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Express.js</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">MySQL</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">AWS: &nbsp;&nbsp;&nbsp; EC2, RDS</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">YAML</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Java: JDBC</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>
               
               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">SQLite</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>
               
               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Power Automate</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Backend;